'use client';

import { useEffect, useState } from 'react';
import { X } from 'lucide-react';
import { cn } from '@/lib/utils';

type ToastProps = {
    id: string;
    title: string;
    description: string;
    type: 'default' | 'destructive' | 'success';
    onDismiss: (id: string) => void;
};

export function Toast({ id, title, description, type, onDismiss }: ToastProps) {
    const [isVisible, setIsVisible] = useState(true);

    useEffect(() => {
        const timer = setTimeout(() => {
            handleDismiss();
        }, 5000);

        return () => clearTimeout(timer);
    }, []);

    const handleDismiss = () => {
        setIsVisible(false);
        setTimeout(() => onDismiss(id), 300);
    };

    return (
        <div
            className={cn(
                'fixed bottom-4 right-4 z-50 w-full max-w-sm rounded-lg p-4 shadow-lg transition-all duration-300',
                isVisible ? 'translate-y-0 opacity-100' : 'translate-y-2 opacity-0',
                {
                    'bg-white text-gray-900': type === 'default',
                    'bg-red-500 text-white': type === 'destructive',
                    'bg-green-500 text-white': type === 'success',
                }
            )}
        >
            <div className="flex items-start justify-between">
                <div className="flex-1 space-y-1">
                    <h3 className="text-sm font-medium">{title}</h3>
                    <p className="text-sm opacity-90">{description}</p>
                </div>
                <button
                    onClick={handleDismiss}
                    className="ml-4 rounded-full p-1 opacity-70 transition-opacity hover:opacity-100 focus:outline-none focus:ring-2 focus:ring-offset-2"
                >
                    <X className="h-4 w-4" />
                </button>
            </div>
        </div>
    );
}
